module.exports = __webpack_public_path__ + "static/media/eduction_btm_2.86917923.png";